module.exports = __webpack_public_path__ + "img/display.930d56ff.svg";